module.exports = __webpack_public_path__ + "img/page-12.6da0490f.jpg";